<div *ngIf="cardInfo() as cardInfo">
  <mat-card>
    <mat-card-header [style.margin-left]="!showAvatar ? (AVATAR_WIDTH + 16).toString() + 'px' : null">
      <div matCardAvatar *ngIf="showAvatar">
        <glxy-avatar [width]="AVATAR_WIDTH" icon="sync_alt" backgroundColor="white" textColor="#9E9E9E"></glxy-avatar>
      </div>
      <mat-card-title>
        <span *ngIf="headerText(); else unknown" class="title">{{ headerText() }}</span>
        <ng-template #unknown>
          <span class="title">{{ 'ACTIVITY.UNKNOWN_TITLE' | translate }}</span>
        </ng-template>
      </mat-card-title>
      <mat-card-subtitle>
        <p *ngIf="cardInfo.effectiveDate !== null" class="effective-date">
          {{ cardInfo.effectiveDate | date: dateFormat }}
        </p>
      </mat-card-subtitle>
    </mat-card-header>
    <mat-card-content [style.margin-left]="(AVATAR_WIDTH + 16).toString() + 'px'">
      <div *ngIf="cardInfo.noteBody">
        <crm-collapsible-section [maxHeightPx]="100">
          <p class="note-body">
            <span [innerHtml]="cardInfo.noteBody | sanitizeHtml"></span>
          </p>
        </crm-collapsible-section>
      </div>
    </mat-card-content>
  </mat-card>
</div>
